import ApiModel from './globals/ApiModel';

export default class StandSecurityInstructionModel extends ApiModel {
  static get path() {
    return '/backend/stand_security_instructions/{?id}';
  }
}
